import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AppointmentCalendarEvent, CalendarEventType } from '../../../types';

interface Props {
  event: AppointmentCalendarEvent;
}
export const AppointmentEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'appointment' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  background: theme.colors.white,
  boxShadow: theme.shadows.light,
});
